import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import type { Technology } from '@/types/entities'

interface TechnologyViewDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    technology: Technology | null
}

export function TechnologyViewDialog({ open, onOpenChange, technology }: TechnologyViewDialogProps) {
    const { t } = useTranslation()
    if (!technology) return null

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>{t('technologies.viewTechnology')}</DialogTitle>
                    <DialogDescription>
                        {t('technologies.viewTechnologyDescription')}
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4">
                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.manufacturer')}
                        </label>
                        <p className="text-sm mt-1">{technology.manufacturer}</p>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.category')}
                        </label>
                        <p className="text-sm mt-1">{technology.category}</p>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.model')}
                        </label>
                        <p className="text-sm mt-1">{technology.model}</p>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.description')}
                        </label>
                        <p className="text-sm mt-1">{technology.description || '-'}</p>
                    </div>

                    {technology.createdAt && (
                        <div>
                            <label className="text-sm font-medium text-muted-foreground">
                                {t('technologies.createdAt')}
                            </label>
                            <p className="text-sm mt-1">
                                {new Date(technology.createdAt).toLocaleString()}
                            </p>
                        </div>
                    )}

                    {technology.updatedAt && (
                        <div>
                            <label className="text-sm font-medium text-muted-foreground">
                                {t('technologies.updatedAt')}
                            </label>
                            <p className="text-sm mt-1">
                                {new Date(technology.updatedAt).toLocaleString()}
                            </p>
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}
